import { useAuthenticationContext } from '@festina-life/authentication'
import type { Optional } from '@festina-life/core'

import { UserName } from './UserName'

type Props = {
  userId: Optional<string>
}

export const CreatedBy = ({ userId }: Props) => {
  const { shouldShowUserInfo } = useAuthenticationContext()

  if (!userId) {
    return null
  }

  return shouldShowUserInfo ? <UserName showIcon userId={userId} /> : userId
}
